<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12" max-width="400">
              <v-toolbar color="#F5F5F5" flat>
                <v-toolbar-title
                  >Welcome to the Portfolio Simulation</v-toolbar-title
                >
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    v-model="name"
                    color="#418F7B"
                    :counter="15"
                    :rules="nameRules"
                    label="Name"
                    prepend-icon="mdi-account"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="email"
                    color="#418F7B"
                    :rules="emailRules"
                    label="E-mail"
                    prepend-icon="mdi-email"
                    required
                  ></v-text-field>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      :disabled="!valid"
                      color="#418F7B"
                      text
                      class="mr-4"
                      @click="validate"
                    >
                      Start
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import firebase from "@/main.js";
export default {
  data: () => ({
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 15) || "Name must be less than 15 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    passwordShow: false,
    password: "Sm@rtOrgR0cks",
    passwordRules: [v => !!v || "Password is Required"],
    select: null,

    checkbox: false
  }),
  created() {
    if (firebase.auth().currentUser !== null) {
      this.$store.dispatch("auth/signOutAction");
    }
  },

  computed: {
    currentGame() {
      return this.$store.getters.currentGame;
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        const user = {
          email: this.email,
          password: this.password,
          name: this.name
        };
        this.$store.dispatch("auth/newregisterAction", user);
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>
